// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider, signInWithPopup, signInWithEmailAndPassword, signOut, onAuthStateChanged, getIdToken } from "firebase/auth";

import { ktOnLogin, ktOnLoginFailed, ktOnLogout } from "./composeApp.mjs"
import { setOptions as setMapsOptions, importLibrary as importMapsLibrary } from "@googlemaps/js-api-loader";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAwIsDqzORrkltKlTvszrDnbh5Sphww-fM",
  authDomain: "pontus-ericsson.firebaseapp.com",
  projectId: "pontus-ericsson",
  storageBucket: "pontus-ericsson.firebasestorage.app",
  messagingSenderId: "377242036657",
  appId: "1:377242036657:web:32c5800ec6dff07623b590",
  measurementId: "G-13J8MH9MEX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new OAuthProvider("microsoft.com");
provider.setCustomParameters({
     tenant: "71e172b4-7ac2-4c08-970d-4bc3d9a1d545",
});
var hasStarted = false
onAuthStateChanged(auth, (user) => {
    if (hasStarted) {
        if (user) {
            // User is signed in

            console.log("User signed in:", user);
            console.log("User UID:", user.uid);
            ktOnLogin(user.email)
        } else {
            // User is signed out
            ktOnLogout()
            console.log("No user is signed in.");
        }
    }
});

export function jsFirebaseIdToken(callback) {
    if (auth.currentUser) {
        auth.currentUser.getIdToken()
                .then((idToken) => {
                    callback(idToken);
                    console.log("ID Token:", idToken);
                })
                .catch((error) => {
                    callback(null);
                    console.error("Error retrieving ID Token:", error);
                });
    } else {
        callback(null);
    }
}

export function jsFirebaseUser() {
    hasStarted = true
    if (auth.currentUser) {
        return auth.currentUser.email;
    }
    return null;
}

export function jsLogout() {
    signOut(auth)
}

export function jsLogin() {
    const result = signInWithPopup(auth, provider)
        .then((result) => {
                // The signed-in user info
                const user = result.user;
                console.log("User signed in:", user);

                // Access the OAuth token
                const credential = OAuthProvider.credentialFromResult(result);
                const accessToken = credential.accessToken;
                console.log("Access Token:", accessToken);
            })
            .catch((error) => {
                ktOnLoginFailed(error)
                console.error("Error during sign-in:", error);
            });

}

export function jsLoginWithEmail(email, password) {
    signInWithEmailAndPassword(auth, email, password)
        .catch((error) => {
            ktOnLoginFailed(error && error.message ? error.message : String(error))
            console.error("Error during email sign-in:", error);
        });
}

export function jsOpenMaps(address) {
    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsUrl, '_blank');
}

export function jsDownloadImage(base64, fileName) {
    // Image URLs are cross-origin, where the anchor's download attribute is
    // ignored — so Kotlin fetches the bytes and we hand the browser a blob.
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const url = URL.createObjectURL(new Blob([bytes], { type: "image/jpeg" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export function jsReload() {
    window.location.reload();
}

export function jsStorageGet(key) {
    return window.localStorage.getItem(key);
}

export function jsStorageSet(key, value) {
    window.localStorage.setItem(key, value);
}
// --- Google Maps (Prospekt → Fastigheter) ------------------------------------
// Browser key for the Maps JavaScript API. Browser keys are public by design;
// restrict it by HTTP referrer in the GCP console. Empty = Google's
// "for development purposes only" mode (dimmed map, still usable locally).
const MAPS_API_KEY = "AIzaSyBIXmPZL0S5a7sOmA1G0g9gnMWWhRPHoPI";
setMapsOptions({ key: MAPS_API_KEY, v: "weekly" });

// Material icon paths for the callout's status row (24×24 viewBox).
const ICON_PATHS = {
    contact: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    offer: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z",
    crm: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z",
};

function statusIcon(kind, present, hint) {
    const ns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(ns, "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("width", "16");
    svg.setAttribute("height", "16");
    svg.style.fill = present ? "#1a1a1a" : "#c8c8c8";
    const title = document.createElementNS(ns, "title");
    title.textContent = present ? hint : "Saknas: " + hint.toLowerCase();
    const path = document.createElementNS(ns, "path");
    path.setAttribute("d", ICON_PATHS[kind]);
    svg.append(title, path);
    return svg;
}

// Built with textContent, never innerHTML: titles come from scraped notices.
function calloutContent(pin, onOpen) {
    const root = document.createElement("div");
    root.style.cssText = "font-family: Roboto, Arial, sans-serif; max-width: 260px; cursor: pointer;";
    const row = document.createElement("div");
    row.style.cssText = "display: flex; align-items: center; gap: 6px; margin-bottom: 4px;";
    const pill = document.createElement("span");
    pill.textContent = pin.label;
    pill.style.cssText = `background: ${pin.color}; color: #fff; border-radius: 999px; padding: 1px 8px; font-size: 11px; font-weight: 600;`;
    row.append(pill,
        statusIcon("contact", pin.hasContact, pin.hints.contact),
        statusIcon("offer", pin.hasOffer, pin.hints.offer),
        statusIcon("crm", pin.hasCrm, pin.hints.crm));
    const title = document.createElement("div");
    title.textContent = pin.title;
    title.style.cssText = "font-weight: 600; font-size: 14px; margin-bottom: 2px;";
    root.append(row, title);
    if (pin.subtitle) {
        const sub = document.createElement("div");
        sub.textContent = pin.subtitle;
        sub.style.cssText = "font-size: 12px; color: #555; margin-bottom: 4px;";
        root.append(sub);
    }
    const open = document.createElement("div");
    open.textContent = "Visa detaljer ›";
    open.style.cssText = "font-size: 12px; font-weight: 600; color: #fe311b;";
    root.append(open);
    root.addEventListener("click", () => onOpen(pin.id));
    return root;
}

// Returns a handle at once; the map itself appears when the library has loaded.
// Pins pushed before that are kept and applied on load. keepCamera: the
// camera was restored, so don't fit the first pin set.
export function jsMapCreate(element, lat, lng, zoom, keepCamera) {
    const handle = { map: null, markers: [], pending: null, info: null, skipFit: keepCamera };
    importMapsLibrary("maps").then(({ Map, InfoWindow }) => {
        handle.map = new Map(element, {
            center: { lat, lng },
            zoom,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            clickableIcons: false,
        });
        handle.info = new InfoWindow();
        handle.map.addListener("click", () => handle.info.close());
        if (handle.pending) {
            const [pinsJson, onOpen] = handle.pending;
            handle.pending = null;
            jsMapSetPins(handle, pinsJson, onOpen);
        }
    });
    return handle;
}

// pinsJson: [{id, lat, lng, title, color, label, subtitle, hasContact, hasOffer,
// hasCrm, hints}]. Replaces all markers and fits them. A marker tap opens its
// callout; a callout tap calls onOpen(id).
export function jsMapSetPins(handle, pinsJson, onOpen) {
    if (!handle.map) {
        handle.pending = [pinsJson, onOpen];
        return;
    }
    handle.info.close();
    handle.markers.forEach((m) => m.setMap(null));
    const pins = JSON.parse(pinsJson);
    const bounds = new google.maps.LatLngBounds();
    handle.markers = pins.map((pin) => {
        const marker = new google.maps.Marker({
            map: handle.map,
            position: { lat: pin.lat, lng: pin.lng },
            title: pin.title,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 8,
                fillColor: pin.color,
                fillOpacity: 1,
                strokeColor: "#ffffff",
                strokeWeight: 2,
            },
        });
        marker.addListener("click", () => {
            handle.info.setContent(calloutContent(pin, onOpen));
            handle.info.open({ map: handle.map, anchor: marker });
        });
        bounds.extend(marker.getPosition());
        return marker;
    });
    if (handle.skipFit) {
        handle.skipFit = false;
    } else if (pins.length === 1) {
        handle.map.setCenter(bounds.getCenter());
        handle.map.setZoom(12);
    } else if (pins.length > 1) {
        handle.map.fitBounds(bounds, 48);
    }
}

// Current camera as "lat,lng,zoom", or null before the map has loaded.
export function jsMapGetCamera(handle) {
    if (!handle.map) return null;
    const c = handle.map.getCenter();
    return `${c.lat()},${c.lng()},${handle.map.getZoom()}`;
}
